import Slider from "rc-slider";
import {useController, useFormContext} from "react-hook-form";

import {SliderFieldProps} from "@/components/form/fields/SliderField/SliderField.types.ts";
import {SliderFieldInput} from "@/components/form/fields/SliderField/SliderFieldInput.tsx";

import "rc-slider/assets/index.css";
import {FormLabel} from "@/components/form/FormLabel";

import styles from "./SliderField.module.scss";

export const SliderField = ({
  className,
  name,
  label,
  defaultValue,
  min,
  max,
  step = 1,
  inputScale = 1,
}: SliderFieldProps) => {
  const {control} = useFormContext();
  const {
    field: {value, onChange},
  } = useController({control, name, defaultValue});

  const commitInput = () => {
    const clamped = Math.min(Math.max(value, min), max);
    onChange(min + Math.round((clamped - min) / step) * step);
  };

  return (
    <div className={className}>
      <div className={styles.header}>
        <FormLabel forId={name} className={styles.label}>{`${label}:`}</FormLabel>
        <SliderFieldInput
          id={name}
          value={value / inputScale}
          min={min / inputScale}
          max={max / inputScale}
          step={step / inputScale}
          invalid={value < min || value > max || (value - min) % step !== 0}
          onChange={(inputValue) => onChange(inputValue * inputScale)}
          onCommit={commitInput}
        />
      </div>
      <div className={styles.sliderWrapper}>
        <Slider
          className={styles.slider}
          defaultValue={defaultValue}
          value={value}
          step={step}
          min={min}
          max={max}
          ariaLabelForHandle={label}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
